<template>
  <div class="ms-date">
    <p>{{ propsFilter.label }}</p>
    <el-date-picker
      v-if="!isRange"
      v-model="date"
      type="date"
      placeholder="Elija una fecha"
    />
    <el-date-picker
      v-show="isRange"
      v-model="date"
      type="daterange"
      range-separator="A"
      start-placeholder="Fecha inicial"
      end-placeholder="Fecha final"
    />
    <span>Habilitar rango de fechas: <el-checkbox v-model="isRange"/></span>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'MsDatePicker',
  props: {
    propsFilter: {
      type: Object,
      default: null
    },
    propertyFilter: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isRange: !!this.$route.query.startDateFilter
    }
  },
  computed: {
    date: {
      get () {
        let currentQuery = this.$route.query
        let _date = null
        if (currentQuery[this.propertyFilter] !== undefined) {
          _date = currentQuery[this.propertyFilter] ? moment(currentQuery[this.propertyFilter]).toDate() : null
        } else {
          if (this.isRange) {
            _date = []
            _date.push(moment(currentQuery.startDateFilter).toDate())
            _date.push(moment(currentQuery.endDateFilter).toDate())
          } else {
            _date = ''
          }
        }
        return _date
      },
      set (value) {
        this.$emit('getFilterValue', value)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .ms-date{
    display: flex;
    flex-direction: column;
    span{
      margin: 15px 0 0 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_shared/catalogForm/ms-datepicker.vue